// filters imports
import { SumByPipe } from './sum-by';
import { StartEndSummaryPipe } from './start-end-summary';
import { SignPipe } from './sign';
import { RevisionDetailsPipe } from './revision-details';
import { PercentageIncreasePipe } from './percentage-increase';
import { OrderByListPipe } from './order-by-list';
import { ObjectLengthPipe } from './object-length';
import { AddressPipe } from './address';
import { ContactPipe } from './contact';
import { CountryNamePipe } from './country-name';
import { EllipsisPipe } from './ellipsis';
import { FormatPeriodPipe } from './format-period';
import { HighlightPipe } from './highlight';
import { IgnorePipe } from './ignore';
import { IsEmptyPipe } from './is-empty';
import { LanguageNamePipe } from './language-name';
import { UpperCaseFirstPipe } from './upper-case-first';

export const filters: any[] = [
  // filters export
  SumByPipe,
  StartEndSummaryPipe,
  SignPipe,
  RevisionDetailsPipe,
  PercentageIncreasePipe,
  OrderByListPipe,
  ObjectLengthPipe,
  AddressPipe,
  ContactPipe,
  CountryNamePipe,
  EllipsisPipe,
  FormatPeriodPipe,
  HighlightPipe,
  IgnorePipe,
  IsEmptyPipe,
  LanguageNamePipe,
  UpperCaseFirstPipe,
];
